import { View } from "react-native";
import EmergencyContact from "./EmergencyContact";
import CareContext, { type MedicalFertilityDestination } from "./CareContext";
import PersonalMedicalInfo from "./PersonalMedicalInfo";
import type { PersonalMedicalData } from "../types";

type Props = {
  personalMedical: PersonalMedicalData;
  onNavigate: (destination: MedicalFertilityDestination) => void;
};

export default function MedicalFertilityDetail({
  personalMedical,
  onNavigate,
}: Props) {
  return (
    <View>
      <CareContext onNavigate={onNavigate} />
      <PersonalMedicalInfo data={personalMedical} onNavigate={onNavigate} />
      <EmergencyContact contact={personalMedical.emergencyContact} />
    </View>
  );
}
